import dayjs from "dayjs";

// Shared date-range presets for the Copilot Dashboard header chips and EmptyState quick actions.
export const PRESETS = [
  { label: "This Month", key: "this_month", days: null },
  { label: "Last Month", key: "last_month", days: null },
  { label: "Today", key: "today", days: 0 },
  { label: "Last 7d", key: "7d", days: 7 },
  { label: "Last 30d", key: "30d", days: 30 },
  { label: "Last 90d", key: "90d", days: 90 },
  { label: "Custom", key: "custom", days: null },
];

export const DEFAULT_PRESET_KEY = "this_month";

const PRESETS_BY_KEY = Object.fromEntries(PRESETS.map((p) => [p.key, p]));

// Computes the from/to dayjs range for a non-custom preset key. Custom has no
// deterministic range — its dates come from wherever the caller stores them
// (state or URL params), not from this function.
export const getPresetRange = (presetKey) => {
  const preset = PRESETS_BY_KEY[presetKey];
  if (!preset || preset.key === "custom") return null;

  if (preset.key === "this_month") {
    return { from: dayjs().startOf("month"), to: dayjs() };
  }
  if (preset.key === "last_month") {
    return {
      from: dayjs().subtract(1, "month").startOf("month"),
      to: dayjs().subtract(1, "month").endOf("month"),
    };
  }
  return {
    from: preset.days === 0 ? dayjs() : dayjs().subtract(preset.days, "day"),
    to: dayjs(),
  };
};
